// extracted by mini-css-extract-plugin
export default {"faq":"faq_faq__1JUit","text":"faq_text__6zkYv"};